import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { getWelcomeSmsLogs, resendWelcomeSms } from "./_welcomeSmsLogsAction";

interface WelcomeSmsLogsState {
  data: any[];
  totalRecord: number;
  currentPage: number;
  totalPages: number;
  search: string;
  statusFilter: string;
  isLoading: boolean;
  isSuccess: boolean;
  responseCode: number | null;
  responseMessage: string;
  errorMessage: string;
}

const initialState: WelcomeSmsLogsState = {
  data: [],
  totalRecord: 0,
  currentPage: 1,
  totalPages: 1,
  search: "",
  statusFilter: "",
  isLoading: false,
  isSuccess: false,
  responseCode: null,
  responseMessage: "",
  errorMessage: "",
};

export const welcomeSmsLogsList = createSlice({
  name: "welcomeSmsLogsList",
  initialState,
  reducers: {
    setWelcomeSmsStatusFilter: (state, action: PayloadAction<string>) => {
      state.statusFilter = action.payload;
    },
    setWelcomeSmsSearch: (state, action: PayloadAction<string>) => {
      state.search = action.payload;
    },
  },
  extraReducers(builder) {
    builder
      .addCase(getWelcomeSmsLogs.pending, (state) => {
        state.isLoading = true;
        state.isSuccess = false;
      })
      .addCase(getWelcomeSmsLogs.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.data = payload.data.logs || [];
        state.totalRecord = payload.data.pagination.total || 0;
        state.currentPage = payload.data.pagination.page || 1;
        state.totalPages = payload.data.pagination.pages || 1;
        if (payload._filters) {
          state.search = payload._filters.search ?? state.search;
          state.statusFilter = payload._filters.status ?? state.statusFilter;
        }
        state.isSuccess = true;
        state.responseCode = payload.responseCode;
        state.responseMessage = payload.responseMessage || "";
      })
      .addCase(getWelcomeSmsLogs.rejected, (state, { payload }) => {
        state.isLoading = false;
        state.errorMessage = payload as string;
      })
      .addCase(resendWelcomeSms.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(resendWelcomeSms.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.responseCode = payload.responseCode;
        state.responseMessage = payload.responseMessage || "";
      })
      .addCase(resendWelcomeSms.rejected, (state, { payload }) => {
        state.isLoading = false;
        state.errorMessage = payload as string;
      });
  },
});

export const { setWelcomeSmsStatusFilter, setWelcomeSmsSearch } =
  welcomeSmsLogsList.actions;
